
export default "/assets/list-bullet-micro.99205410.svg"